import config from '../config/config';
export const baseUrl = config.URL;
